import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {Link} from 'react-router-dom'
import accounting from 'accounting'
import EmailModal from '../utils/EmailModal'
import Dls from "../../lib";
import {api} from "../../api"
import {
    Table,
    Segment,
    Breadcrumb,
    Button,
    Input,
    Label,
    Confirm,
    Dropdown,
    Modal,
    Dimmer,
    Loader
} from "semantic-ui-react";
import {
    loadShipmentById,
    updateShipmentModelInStore,
    updateShipmentTracking,
    fulfillShipment,
    unFulfillShipment,
    deleteShipment,
    updateLinePricingFromForm,
    updateInvoiceDate,
    updateTaxCode
} from '../../actions/shipment'
import AddressToolTip from '../orders/parts/AddressToopTips'
import PDFDisplay from '../utils/DisplayPDF'
const options = [
    { key: 'shipment', text: 'Packing Slip', value: 'shipment' },
    { key: 'invoice', text: 'Invoice', value: 'invoice' }
]
class ShipmentViewPage extends Component {
    constructor() {
        super();
        this.state = {
            type: '',
            dropShipOriginal: '',
            deleteConfirm: false,
            updating: false,
            pdfViewer: false,
            base64String: "",
            fieldNames: {
                bill_to: 'Bill To',
                ship_to: 'Ship To',
                warehouse: 'Ship From',
                ship_on: 'Planned Ship Date'
            },
            emailModalOpen: false,
            isUpdatePrice: false,
            showFreightChargeInput: false,
            freightTotal: 0,
            loading: false,
            newInvoiceDate: "",
            showInvoiceDateInput: false,
            isUpdateTaxCode: false,
            taxCode: 0,
            syncHostLoading: false
        }
    }
    componentDidMount() {
        const {jwt} = this.props;
        const {id, type} = this.props.match.params;
        let fieldNames = {
            bill_to: 'Bill To',
            ship_to: 'Ship To',
            warehouse: 'Ship From',
            ship_on: 'Planned Ship Date'
        };
        this.setState({
            loading: true
        })
        this.props.loadShipmentById(jwt, id).then(res => {
            const {data} = res.data;
            if (data.acct_type === 'Vendor Credit') {
                fieldNames = {
                    bill_to: 'Vendor Billing',
                    ship_to: 'Return To',
                    warehouse: 'Return From',
                    ship_on: 'Planned Return Date'
                };
            }
            if (data.acct_type === 'Invoice') {
                fieldNames = {
                    bill_to: 'Customer Billing',
                    ship_to: 'Ship To',
                    warehouse: 'Ship From',
                    ship_on: 'Planned Ship Date'
                };
            }
            if (data.acct_type === 'Credit Memo') {
                fieldNames = {
                    bill_to: 'Customer Billing',
                    ship_to: 'Ship From',
                    warehouse: 'Return To',
                    ship_on: 'Planned Return Date'
                };
            }
            if (data.acct_type === 'Bill') {
                fieldNames = {
                    bill_to: 'Vendor Bill From',
                    ship_to: 'Ship From',
                    warehouse: 'Ship To',
                    ship_on: 'Planned Ship Date'
                };
            }

            let dropShipOriginal = '/shipments/receiving';
            if (type === 'receiving') {
                dropShipOriginal = '/shipments/shipping'
            }
            
            this.setState({
                type: type, dropShipOriginal: dropShipOriginal, fieldNames: fieldNames, loading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
        });;


    }

    componentWillReceiveProps(props) {
        const {jwt} = this.props;
        const {id, type} = props.match.params;
        if (!_.isNaN(parseInt(this.props.shipment.id))) {
            if (parseInt(id) !== parseInt(this.props.shipment.id)) {
                this.props.loadShipmentById(jwt, id).catch(err => {
                    Dls.apiErrorAlert(err);
                });;
                let dropShipOriginal = '/shipments/receiving';
                if (type === 'receiving') {
                    dropShipOriginal = '/shipments/shipping'
                }
        
                this.setState({
                    type, dropShipOriginal
                });
            }
        }
    }

    onCloseEmailModal = () => {
        this.setState({
            emailModalOpen: false
        })
    }

    onDeleteConfirmCancelled = () => {
        this.setState({
            deleteConfirm: false
        })
    }

    updateTracking = () => {
        const {id, tracking_company, tracking_number} = this.props.shipment;
        this.setState({
            updating: true
        });
        this.props.updateShipmentTracking(this.props.jwt, id, tracking_company, tracking_number).then(res => {
            this.setState({
                updating: false
            })
        }).catch(err => {
            this.setState({
                updating: false
            });
            Dls.apiErrorAlert(err);
        })
    }
    
    onDeleteConfirmed = () => {
        this.props.deleteShipment(this.props.jwt, this.props.shipment.id).then(res => {
            const {type} = this.state;
            this.props.history.replace(`/shipments/${type}/${Dls.pagination.shipments(type==='receiving' ? 'inbound' : 'outbound')}`)
        }).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    onShippedClick = () => {
        this.props.fulfillShipment(this.props.jwt, this.props.shipment.id).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    onReopenOrderClicked = () => {
        this.props.unFulfillShipment(this.props.jwt, this.props.shipment.id).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    onQbSyncClick = () => {

    }

    onLinksSyncClick = () => {

    }

    getTaxName = (type) => {
        const {shipment} = this.props;
        const tax_id = shipment.order ? shipment.order.tax_id : 0;
        const {taxes} = this.props;
        const tax = taxes.filter(i => {
            return i.value === _.toInteger(tax_id);
        });
        if (tax.length > 0) {
            if (type === 'rate') {
                return tax[0].rate;
            } else {
                return tax[0].text;
            }
        }
        return "";
    }

    getLineTotal = () => {
        let total = 0;
        _.each(this.props.shipment.lines, line => {
            const {order_line} = line;
            total = total + (Math.abs(_.toInteger(line.quantity)) * _.toNumber(_.isObject(order_line) ? order_line.price : 0));
        });
        return Math.abs(total);
    }

    getTaxTotal = () => {
        const taxRate = this.getTaxName('rate');
        const lineTotal = this.getLineTotal();
        return taxRate * lineTotal;
    }

    getWarehouseName = () => {
        const {warehouse_id} = this.props.shipment;
        const {warehouses} = this.props;
        const warehouse = warehouses.filter(i => {
            return i.value === _.toString(warehouse_id);
        });
        if (warehouse.length > 0) {
            return warehouse[0].text;
        }
        return "";
    }

    _onPrintOptionSelected = (value) => {
        const params = {
            docType: value,
            docId: this.props.shipment.id
        };
        api.pdf(this.props.jwt, params).then(res => {
            const {data} = res.data;
            this.setState({
                pdfViewer: true,
                base64String: data
            });
        })
    }

    onPdfModalClose = () => {
        this.setState({
            pdfViewer: false
        })
    }

    addFreightChargeButtonClicked = () => {
        this.setState({
            showFreightChargeInput:!this.state.showFreightChargeInput
        });
    }

    saveFreightCharge = () => {
        const {shipment, jwt} = this.props;
        this.setState({
            loading:true
        });
        api.shipment.addFreightCharge(jwt, shipment.id, this.state.freightTotal).then(res => {
            this.props.loadShipmentById(jwt, shipment.id).then(res => {
                this.setState({
                    loading:false,
                    freightTotal: 0,
                    showFreightChargeInput: false
                })
            }).catch( err => {
                throw err;
            })
        }).catch(err => {
            Dls.apiErrorAlert(err);
        })
    }

    changeInvoiceDateBtnClicked = () => {
        this.setState({
            showInvoiceDateInput:!this.state.showInvoiceDateInput
        });
    }

    updateInvoiceDate = () => {
        const {shipment, jwt} = this.props;
        this.setState({
            loading:true
        });
        api.shipment.updateInvoideDate(jwt, shipment.id, this.state.newInvoiceDate).then(res => {
            this.props.updateInvoiceDate(this.state.newInvoiceDate);
            this.setState({
                loading:false,
                newInvoiceDate: "",
                showInvoiceDateInput: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                loading:false
            });
        })
    }

    updatePriceButtonClicked = () => {
        this.setState({
            isUpdatePrice: true
        });
    }

    onUpdatePrice = (line, price) => {
        this.props.updateLinePricingFromForm(line, price);
    }

    updateNewPricing = () => {
        const {order_id, lines} = this.props.shipment;
        const order_lines = [];
        _.each(lines, l => {
            order_lines.push({
                id: l.order_line_id,
                price: l.order_line.price
            })
        });
        api.shipment.updatePricing(this.props.jwt, order_id, order_lines).then(res => {
            this.setState({
                isUpdatePrice: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    updateTaxCodeClick = () => {
        let taxId = 0;
        const {order} = this.props.shipment;
        if (_.isObject(order)) {
            taxId = order.tax_id;
        }
        this.setState({
            isUpdateTaxCode: true,
            taxCode: taxId
        });
    }

    updateTaxCode = () => {
        api.shipment.updateTaxCodeOnOrder(this.props.jwt, this.props.shipment.id, this.state.taxCode).then(res => {
            this.props.updateTaxCode(this.state.taxCode);
            this.setState({
                isUpdateTaxCode: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                loading:false
            });
        })
    }

    onTaxCodeChange = (value) => {
        this.setState({
            taxCode: value
        });
    }

    getEmailAddress = () => {
        const {shipment} = this.props;
        let email = shipment.bill_to.email ? shipment.bill_to.email : shipment.relation_name.email;
        if (shipment.order.contact) {
            email = shipment.order.contact.email;
        }
        return email;
    }

    getContactName = () => {
        const {shipment} = this.props;
        let name = `${shipment.relation_name.given_name} ${shipment.relation_name.family_name}`;
        if (shipment.order.contact) {
            name = shipment.order.contact.name;
        }
        return name;
    }

    processInHostScm = () => {
        this.setState({
            syncHostLoading: true
        });
        api.shipment.processInHostScm(this.props.jwt, this.props.shipment.id).then(res => {
            const {data} = res.data;
            this.props.updateShipmentModelInStore('y3pl_shipment_id', data.y3pl_shipment_id);
            this.setState({
                syncHostLoading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                syncHostLoading:false
            });
        })
    }

    createInHostScm = () => {
        this.setState({
            syncHostLoading: true
        });
        api.shipment.createInHostScm(this.props.jwt, this.props.shipment.id).then(res => {
            this.props.updateShipmentModelInStore('y3pl_id', '_temp_1');
            this.props.updateShipmentModelInStore('y3pl_shipment_id', '_temp_2');
            this.setState({
                syncHostLoading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                syncHostLoading:false
            });
        })
    }

    render() {
        const {shipment, updateShipmentModelInStore} = this.props;
        const {type, dropShipOriginal, fieldNames} = this.state;
        if (shipment.id) {
            return (
                <div>
                    <div className="row" style={{ marginBottom: "5px" }}>
                        <div className="col-md-8">
                            <Breadcrumb size="huge">
                                <Breadcrumb.Section>
                                    Orders
                                </Breadcrumb.Section>
                                <Breadcrumb.Divider />
                                {shipment.order.id ? <Breadcrumb.Section>
                                    <Link to={`/${_.kebabCase(shipment.order.type)}s/${shipment.order.id}/view`}>{shipment.order.so}</Link>
                                </Breadcrumb.Section> : null}
                                <Breadcrumb.Divider />
                                <Breadcrumb.Section>
                                    <Link
                                        to={`/shipments/${type}/${Dls.pagination.shipments(type==='receiving' ? 'inbound' : 'outbound')}`}
                                    >
                                        {_.upperFirst(type)} List
                                    </Link>
                                </Breadcrumb.Section>
                                <Breadcrumb.Divider />
                                <Breadcrumb.Section>
                                    {_.upperFirst(type)}
                                </Breadcrumb.Section>
                                <Breadcrumb.Divider />
                                <Breadcrumb.Section>
                                    {_.isObject(shipment.relation_name) ? shipment.relation_name.company_name : ""}
                                </Breadcrumb.Section>
                            </Breadcrumb>
                            <div style={{float: 'right'}}>
                                {shipment.status === 'Pending' ? <Label color='teal' size='mini'>Pending</Label> : null}
                                {shipment.status === 'Shipped' ? <Label color='green' size='mini'>Completed</Label> : null}
                            </div>
                        </div>
                        <div className="col-md-4">
                        
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <Segment>
                                {this.state.loading ? <Dimmer active inverted>
                                    <Loader inverted content='Loading' />
                                </Dimmer> : null}
                                <div className="row">
                                    <div className="col-md-6">
                                        <h3>
                                            {shipment.relation_name.company_name}&nbsp;&nbsp;&nbsp;
                                            <small>
                                                <Dropdown  
                                                onChange={(e, {value}) => {this._onPrintOptionSelected(value)}}
                                                floating options={options} direction='left' text='Print'/>
                                            </small>
                                        </h3>
                                    </div>
                                    <div className="col-md-6">
                                        <div style={{float: 'right'}}>
                                            {!shipment.invoice_number && shipment.status === 'Pending' ? 
                                                <Button color='red' size='mini' 
                                                    onClick={() => {this.setState({deleteConfirm: true})}}>
                                                    Delete
                                                </Button> 
                                            : null}
                                            <Confirm 
                                                content='Delete this shipment? If this shipment is in Links or Host SCM 3PL system, you need to manually cancel it'
                                                open={this.state.deleteConfirm} 
                                                onCancel={this.onDeleteConfirmCancelled} 
                                                onConfirm={this.onDeleteConfirmed} />
                                        </div>
                                        <div style={{float: 'right'}}>
                                            {shipment.status === 'Pending' ? 
                                                <Button color='blue' size='mini' onClick={this.onShippedClick}>Complete</Button> 
                                            : null}
                                        </div>
                                        <div style={{float: 'right'}}>
                                            {shipment.status === 'Shipped' && !shipment.invoice_number? 
                                                <Button color='teal' size='mini' onClick={this.onReopenOrderClicked}>Re-open</Button> 
                                            : null}
                                            {shipment.status === 'Shipped' && (shipment.acct_type === 'Invoice' || shipment.acct_type === 'Bill')? 
                                                <Button color='purple' size='mini' as={Link} to={`/returns/${shipment.id}/create`}>Return</Button> 
                                            : null}
                                        </div>
                                        <div style={{float: 'right'}}>
                                            <Button color='teal' size='mini' onClick={() => {this.setState({emailModalOpen: true})}}>Email</Button>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-md-4">
                                        <div style={{marginTop: '3px'}}>
                                            {fieldNames.bill_to} <br />
                                            <AddressToolTip elementId="billToTip" address={shipment.bill_to} />
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                            {fieldNames.ship_to} <br />
                                            <AddressToolTip elementId="shipToTip" address={shipment.ship_to} />
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                            {fieldNames.warehouse} <br />
                                            <strong>{this.getWarehouseName()}</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div style={{marginTop: '3px'}}>
                                            Order # <br />
                                            <strong>{_.isObject(shipment.order) ? shipment.order.so : ""}<br /></strong>
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                            Order Reference <br />
                                            <strong>{_.isObject(shipment.order) ? shipment.order.reference : ""}<br /></strong>
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                            {fieldNames.ship_on}<br />
                                            <strong>{_.isObject(shipment.order) ? shipment.order.ship_at : ""}<br /></strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div style={{marginTop: '3px'}}>
                                            Drop Ship<br />
                                            <strong>{shipment.drop_ship ? <Link to={`${dropShipOriginal}/${shipment.drop_ship_id}/view`}>View</Link> : "No"} <br /></strong>
                                        </div>  
                                        <div style={{marginTop: '3px'}}>
                                            QB Ref #<br />
                                            <strong>{shipment.invoice_number} <br /></strong>
                                        </div>  
                                        <div style={{marginTop: '3px'}}>
                                            Integration: <br />
                                            {shipment.acct_id ? 
                                                <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='green'>QB</Label> : 
                                                <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='red'>QB</Label>}
                                            {shipment.y3pl_id && shipment.y3pl_shipment_id ? <Label size="mini" color='green'>Host Ready</Label> : null}
                                            {shipment.y3pl_id && !shipment.y3pl_shipment_id ? <Label size='mini' 
                                                disabled={this.state.syncHostLoading} 
                                                as={Button}
                                                loading={this.state.syncHostLoading}
                                                onClick={() => this.processInHostScm()} color='purple'>Host Shipment</Label> : null}
                                            {!shipment.y3pl_id && !shipment.y3pl_shipment_id? <Label 
                                                disabled={this.state.syncHostLoading} 
                                                size='mini' as={Button}
                                                loading={this.state.syncHostLoading}
                                                onClick={() => this.createInHostScm()} color='red'>Host Order</Label> : null}
                                        </div>
                                    </div>
                                </div>
                            
                                <div className="row" style={{marginTop: '10px'}}>
                                    <Table compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>
                                                    SKU
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    Name
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    UOM
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    Total Qty
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    Price
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    Fulfilled Qty
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    Total
                                                </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {_.isArray(shipment.lines) ? shipment.lines.map(line => {
                                                const {inventory, order_line} = line;
                                                return <Table.Row key={line.id}>
                                                    <Table.Cell>
                                                        {inventory.sku}
                                                        {order_line.special_sku ? ` (${order_line.special_sku})`: null}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {inventory.name}
                                                        {order_line.special_name ? ` (${order_line.special_name})`: null}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {order_line.uom}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {order_line.quantity}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {this.state.isUpdatePrice ? <Input type='number' size='mini' value={Math.round(order_line.price * 100) / 100} 
                                                            onChange={(e, {value}) => {this.onUpdatePrice(line, value)}}
                                                        /> : Math.round(order_line.price * 100) / 100}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {Math.abs(line.quantity)}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {accounting.formatMoney(Math.abs(_.toInteger(line.quantity)) * _.toNumber(order_line.price))}
                                                    </Table.Cell>
                                                </Table.Row>
                                            }) : null}
                                        </Table.Body>
                                    </Table>
                                </div>
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-md-10">
                                        Warehouse Notes: <br />
                                        {!_.isEmpty(shipment.comments) ? shipment.comments[0].note : null}
                                    </div>
                                    <div className="col-md-2">
                                        <div style={{marginTop: '3px'}}>
                                            Total Before Tax: <br />
                                            <strong>{accounting.formatMoney(this.getLineTotal())}<br /></strong>
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                        {this.getTaxName('name')} {`(${this.getTaxName('rate')*100}%)`}: <br />
                                            <strong>{accounting.formatMoney(this.getTaxTotal())}<br /></strong>
                                        </div>
                                        <div style={{marginTop: '3px'}}>
                                            Total After Tax: <br />
                                            <strong>{accounting.formatMoney(this.getLineTotal() + this.getTaxTotal())}<br /></strong>
                                        </div>
                                    </div>
                                </div>
                            </Segment>
                        </div>
                    
                        <div className="col-md-4">
                            <Segment>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Courier & Tracking</h3>
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-md-12">
                                        <div style={{marginBottom: '3px'}}><Label size='mini'>Courier Name</Label></div>
                                        <Input fluid size='mini' 
                                            onChange={(e, {value}) => {updateShipmentModelInStore('tracking_company', value)}}
                                            value={shipment.tracking_company ? shipment.tracking_company : ""} />
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-md-12">
                                        <div style={{marginBottom: '3px'}}><Label size='mini'>Tracking #</Label></div>
                                        <Input fluid size='mini' 
                                            onChange={(e, {value}) => {updateShipmentModelInStore('tracking_number', value)}}
                                            value={shipment.tracking_number ? shipment.tracking_number : ""} />
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-md-12">
                                        <Button size="mini" color='teal' onClick={this.updateTracking} disabled={this.state.updating}>
                                            Update
                                        </Button>
                                    </div>
                                </div>
                            </Segment>
                            {shipment.status === 'Shipped' ? 
                            <Segment>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Accounting</h3>
                                    </div>
                                    {shipment.acct_id ? <div className="col-md-12">
                                        Status: <strong>In Quickbook</strong> <br />
                                        {shipment.acct_type} Number: <strong>{shipment.invoice_number}</strong> <br />
                                        Invoice Date: <strong>{shipment.invoice_date}</strong>
                                    </div> : null}

                                    <div className="col-md-12">
                                        {!shipment.acct_id ? <div className="col-md-12" style={{marginTop: '5px'}}>
                                            {!this.state.isUpdatePrice ? <Button size='mini' color='teal' onClick={() => {this.updatePriceButtonClicked()} } >
                                                Update Price
                                            </Button> : null}

                                            {this.state.isUpdatePrice ? <Button size='mini' color='teal' onClick={() => {this.updateNewPricing()} } >
                                                Save Update
                                            </Button> : null}
                                        </div> : null}
                                    </div>

                                    {this.state.showFreightChargeInput ? <div className="col-md-12" style={{marginTop: '10px', paddingLeft: '13px'}}>
                                        <Input value={this.state.freightTotal} 
                                            onChange={(e, {value}) => {this.setState({freightTotal: value})}}
                                            type='number' 
                                            size='mini' />
                                    </div> : null}
                                    <div className="col-md-12">
                                        {!shipment.acct_id ? <div className="col-md-12" style={{marginTop: '5px'}}>
                                            {!this.state.showFreightChargeInput ? <Button size='mini' color='teal' onClick={() => {this.addFreightChargeButtonClicked()} } >
                                                Add Freight Charge
                                            </Button> : null}
                                            {this.state.showFreightChargeInput ? <Button size='mini' color='red' onClick={() => {this.addFreightChargeButtonClicked()} } >
                                                Cancel
                                            </Button> : null}
                                            {this.state.showFreightChargeInput ? <Button size='mini' disabled={this.state.loading} color='teal' onClick={() => {this.saveFreightCharge()} } >
                                                Save Charge
                                            </Button> : null}
                                        </div> : null}
                                    </div>

                                    {this.state.showInvoiceDateInput ? <div className="col-md-12" style={{marginTop: '10px', paddingLeft: '13px'}}>
                                        <Input value={this.state.newInvoiceDate} 
                                            onChange={(e, {value}) => {this.setState({newInvoiceDate: value})}}
                                            type='date' 
                                            size='mini' />
                                    </div> : null}
                                    {!shipment.acct_id ? <div className="col-md-12" style={{marginTop: '5px', paddingLeft: '13px'}}>
                                        {!this.state.showInvoiceDateInput ? <Button size='mini' color='teal' onClick={() => {this.changeInvoiceDateBtnClicked()} } >
                                            Invoice Date: {shipment.invoice_date}
                                        </Button> : null}
                                        {this.state.showInvoiceDateInput ? <Button size='mini' color='red' onClick={() => {this.changeInvoiceDateBtnClicked()} } >
                                            Cancel
                                        </Button> : null}
                                        {this.state.showInvoiceDateInput ? <Button size='mini' disabled={this.state.loading} color='teal' onClick={() => {this.updateInvoiceDate()} } >
                                            Save Change
                                        </Button> : null}
                                    </div> : null}

                                    

                                    <div className="col-md-12">
                                        {this.state.isUpdateTaxCode ? <div className="col-md-12" style={{marginTop: '5px'}}>
                                            <Dropdown 
                                                value={this.state.taxCode}
                                                onChange={(e, {value}) => {this.onTaxCodeChange(value)}}
                                                options={this.props.taxes}
                                                fluid
                                                selection
                                            />
                                        </div> : null}
                                        {!shipment.acct_id ? <div className="col-md-12" style={{marginTop: '5px'}}>
                                            {!this.state.isUpdateTaxCode ? <Button size='mini' color='teal' onClick={() => {this.updateTaxCodeClick()} } >
                                                Update Tax Code
                                            </Button> : null}

                                            {this.state.isUpdateTaxCode ? <Button size='mini' color='teal' onClick={() => {this.updateTaxCode()} } >
                                                Save New Tax Code
                                            </Button> : null}
                                        </div> : null}
                                        
                                    </div>
                                </div>
                            </Segment> : null}

                            {shipment.y3pl_id && !shipment.y3pl_shipment_id ? <Segment>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Host SCM Attention</h3>
                                    </div>
                                </div>
                                <p>
                                    An order has been created in Host SCM, but cannot be processed due to inventory discrepancies (or possible error). If this is a shipment going to customer,
                                    you need to fix inventory quantity issues in Host SCM, and use this button to create a shipment in Host SCM.
                                </p>
                                <p>
                                    If you need to adjust inventory quantities on the order, you should delete this shipment AND cancel the order created in Host SCM. Once done, you 
                                    can create another shipment with new quantities, it will be automatically created again in Host SCM.
                                </p>
                                <p>
                                    <Button loading={this.state.syncHostLoading} disabled={this.state.syncHostLoading} color="teal" size="mini"
                                        onClick={() => {
                                            this.processInHostScm()
                                        }}>
                                        Retry    
                                    </Button>
                                </p>
                            </Segment> : null}
                        </div>
                    </div>
                    <Modal size='large' open={this.state.pdfViewer} onClose={this.onPdfModalClose} closeOnDimmerClick={false}>
                        <Modal.Content>
                            <div className="row" style={{marginBottom: '10px'}}>
                                <div className="col-md-12">
                                    <Button size='mini' color='teal' floated='right' onClick={() => {this.onPdfModalClose()}}>Close</Button>
                                </div>
                            </div>
                            <PDFDisplay pdf={this.state.base64String} />
                        </Modal.Content>
                    </Modal>
                    <EmailModal
                        uid={_.uniqueId()}
                        orderType={shipment.order.type}
                        id={shipment.id}
                        doc="Shipment"
                        to_address={this.getEmailAddress()}
                        contact={this.getContactName()}
                        show={this.state.emailModalOpen}
                        onModalClose={() => {this.onCloseEmailModal()}}
                        jwt={this.props.jwt}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    
                </div>
            );
        }

    }
}

ShipmentViewPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    updateShipmentModelInStore:PropTypes.func.isRequired,
    loadShipmentById: PropTypes.func.isRequired,
    jwt: PropTypes.string.isRequired,
    shipment: PropTypes.object.isRequired,
    warehouses: PropTypes.array.isRequired,
    taxes: PropTypes.array.isRequired,
    updateShipmentTracking: PropTypes.func.isRequired,
    fulfillShipment: PropTypes.func.isRequired,
    unFulfillShipment: PropTypes.func.isRequired,
    deleteShipment: PropTypes.func.isRequired,
    updateLinePricingFromForm: PropTypes.func.isRequired,
    updateInvoiceDate: PropTypes.func.isRequired,
    updateTaxCode: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        shipment: state.shipment.shipment,
        jwt: state.auth.jwt,
        warehouses: state.system.resources.warehouses,
        taxes: state.system.resources.taxes
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadShipmentById,
        updateShipmentModelInStore,
        updateShipmentTracking,
        fulfillShipment,
        unFulfillShipment,
        deleteShipment,
        updateLinePricingFromForm,
        updateInvoiceDate,
        updateTaxCode
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentViewPage)


// WEBPACK FOOTER //
// ./src/components/shipments/ShipmentView.js